import { get, post } from "@/utils/http";

let baseURL = "/meeting";

// 获取会议预约列表
const getAllMeeting = data => get(`${baseURL}/getAllMeeting`, data);

// 获取会议预约履历
const getMeetingHis = data => get(`${baseURL}/getMeetingHis`, data);

// 取消会议预约
const cancelMeeting = data => post(`${baseURL}/cancelMeeting`, { data });

//获取我的预约
const getAllMyMeetingReserve = data => get(`${baseURL}/getAllMyMeetingReserve`, data);

//获取我的会议
const getAllMyMeeting = data => get(`${baseURL}/getAllMyMeeting`, data);

//预约会议
const addMeetingInfo = data =>post(`${baseURL}/addMeetingInfo`, { data });

// 获取会议室当日预约状况
const listMeetingTime = data => get(`${baseURL}/listMeetingTime`, data);

// API
export default {
    getAllMeeting,
    getMeetingHis,
    cancelMeeting,
    getAllMyMeetingReserve,
    getAllMyMeeting,
    addMeetingInfo,
    listMeetingTime
};
